import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import(/* webpackChunkName: "doneVisits" */ './index'),
  loading: () => null,
});
